import { Card, Empty, Table, Typography } from "antd";
import dayjs from "dayjs";
import { Event, EventType, Location } from "@bindeleddet/core/types";
import React from "react";
import { useHistory } from "react-router-dom";
import { formatDateNorwegian, formatTimeNorwegian } from "helpers/dateUtils";

const { Title } = Typography;

interface Props {
  events: Event[];
  loading: boolean;
  eventTypes: EventType[];
}

const PreviousEvents: React.FC<Props> = ({ events, loading, eventTypes }) => {
  const history = useHistory();

  const eventColumns = [
    {
      title: "Visningsnavn",
      dataIndex: "name",
      width: "35%",
      ellipsis: true,
    },
    {
      title: "Type",
      dataIndex: "event_type",
      width: "20%",
      ellipsis: true,
      render: (eventTypeId: number) => eventTypes.find(eventType => eventType.id === eventTypeId)?.title,
    },
    {
      title: "Dato",
      dataIndex: "start",
      render: (start: string) => formatDateNorwegian(start),
      width: "12.5%",
      ellipsis: true,
    },
    {
      title: "Klokkeslett",
      dataIndex: "start",
      render: (start: string) => formatTimeNorwegian(start),
      width: "12.5%",
      ellipsis: true,
    },
    {
      title: "Sted",
      dataIndex: "location",
      width: "10%",
      ellipsis: true,
      render: (location: Location | null) => location?.name ?? "Ikke bestemt",
    },
    {
      title: "Påmeldte",
      dataIndex: "registrations",
      width: "10%",
      ellipsis: true,
      render: (registrations: number, record: unknown) => {
        const event = record as Event;
        return dayjs().isBefore(dayjs(event.open)) ? "Ikke åpnet" : `${registrations}/${event.seats}`;
      },
    },
  ];
  return (
    <>
      <Title level={5}>Tidligere arrangementer</Title>
      <Card>
        <Table
          columns={eventColumns}
          dataSource={events}
          size="small"
          rowKey="id"
          onRow={(record, rowKey) => ({
            onClick: () => {
              if (rowKey === undefined) return null;
              history.push(`/events/${events[rowKey].id}`);
            },
          })}
          locale={{
            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Ingen tidligere arrangementer" />,
          }}
          loading={loading}
        />
      </Card>
    </>
  );
};

export default PreviousEvents;
